import React, {useEffect, useRef, useState} from "react";
import './RegisterLead.scss';
import * as Yup from 'yup';
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import {getRegisterLeadConfigDispatch, registerLead, registerLeadAdamo} from "../LeadAction";
import Divider from "@material-ui/core/Divider";
import FormGroup from "@material-ui/core/FormGroup";
import {Field, withFormik} from "formik";
import {connect} from "react-redux";
import {Grid} from "../../../comun/Grid/Grid";
import MaterialTextField from "../../../comun/Forms/MaterialTextField";
import CheckboxField from "../../../comun/Forms/CheckboxField";
import {validatePhone} from "../../../../validation/basicValidation";
import SelectField from "../../../comun/Forms/SelectField";
import MultiSelectField from "../../../comun/Forms/MultiSelectField";
import {AutocompleteUser} from "../../../comun/AutocompleteUser/AutocompleteUser";
import {hasAnyRole, hasRole} from "../../../../auth/util";
import {filterStands} from "../../Stand/StandAction";
import {documentExists} from "../../Users/UserAction";
import {call} from "../../../../util/utilXhr";
import SignatureCanvas from "react-signature-canvas";
import {validCif, validNif} from "../../../../util/utilValid";
import {existsKeyInCampaign, getValueOrDefault} from "../../../../util/utilCampaign";
import {log} from "../../../../util/utilLog";
import {generateUuid} from "../../../../util/utilUuid";
import {confirmSmsEvent, sendSmsConfirmationEvent} from "../SmsAction";
import ButtonField from "../LeadFormComponents/ButtonField";
import { Typography, LinearProgress, Popover } from '@mui/material';
import InputAdornment  from '@mui/material/InputAdornment';


const getPhoneConfirmedEnabled = (campaign, user) => {
    let phoneConfirmationEnabled = getValueOrDefault('lead.register.sms_confirmation.enable', campaign, 'false');
    phoneConfirmationEnabled = (phoneConfirmationEnabled === 'true');
    let roles = getValueOrDefault('lead.register.sms_confirmation.roles_excluded', campaign, '');
    roles = roles.split(',');
    return phoneConfirmationEnabled && !hasAnyRole(user, roles);
}

const getCheckedValue = (clause) => {
    return clause.privacyClausePrivacyClauseValues.find(a => a.privacyClauseValue.value === "SI");
}
const getUnCheckedValue = (clause) => {
    return clause.privacyClausePrivacyClauseValues.find(a => a.privacyClauseValue.value === "Off");
}
export let RegisterLeadAdamo = ({user, onRegisterLeadConfig, ...props}) => {
    const [documents, setDocuments] = useState([]);
    const [clauses, setClauses] = useState([]);
    React.useEffect(() => {
        onRegisterLeadConfig().then((res) => {
            setDocuments(res.documentTypeList);
            setClauses(res.privacyClauses);
        })
    }, []);
    return (
        <RegisterLeadFormAdamo documents={documents} clauses={clauses} defaultClauses={[...clauses]}/>
    )
}

const mapRegisterLeadDispatchToProps = dispatch => {
    return {
        onRegisterLeadConfig: async () => {
            return await getRegisterLeadConfigDispatch()(dispatch);
        }
    }
}
RegisterLeadAdamo = connect(null, mapRegisterLeadDispatchToProps)(RegisterLeadAdamo);

export let RegisterLeadFormAdamo = ({
                                   onCheckDocument,
                                   onConfirmSms,
                                   campaign,
                                   clauses,
                                   user,
                                   documents,
                                   getFieldValue,
                                   setFieldValue,
                                   setFieldError,
                                   isSubmitting,
                                   onSendSms,
                                   handleSubmit,
                                   values,
                                   defaultClauses,
                                   setErrors,
                                   isValid,
                                   ...props
                               }) => {
    const getStandFilterParams = () => {
        const res = {};

        let key = 'teamLeader';
        if (hasRole(user, 'COMMERCIAL_PROMOTER')) {
            key = 'commercialPromoter';
        }
        res[key] = user.id;
        res.cleaned = true;
        return res;
    }
    const submit = (vals) => {
        log(`Empezando a registrar Lead de ${user.id}`, "info");
        if (canvasRef.isEmpty()) {
            setCanvasEmpty(true);
            vals.preventDefault();
            return false;
        } else {
            setCanvasEmpty(false);
            setFieldValue('sign', canvasRef.getTrimmedCanvas()
                .toDataURL('image/png').replace('data:image/png;base64,', ''))
            try {
                canvasRef.clear();
                handleSubmit(vals);
                if (Object.keys(values.clauses).length === 4) {
                    return;
                }
                setSmsconfirmed(false);
                canvasRef.clear();
            } catch (e) {
                console.log('Error' + e)

            }

        }
    }
    const [canvasWidth, setCanvasWidth] = useState(100);
    const [canvasHeight, setCanvasHeight] = useState(56);
    const [canvasEmpty, setCanvasEmpty] = useState(false);
    const [canvasRef, setCanvasRef] = useState();
    const [smsCodeError, setSmsCodeError] = useState(false);
    const [smsConfirmed, setSmsconfirmed] = useState(false);
    const [showingHelp, setShowingHelp] = useState(false);


    const documentRef = useRef(null);
    React.useEffect(() => {
        let franja = getFranjas();
        if (franja.length === 0) {
            return;
        }
        franja = franja.find((f) => f.franja === values.franjas);
        setFieldValue('contactHourLast', franja.horaHasta);
        setFieldValue('contactHour', franja.horaDesde);
    }, [values.franjas])
    const resetCanvas = () => {
        canvasRef.clear();
    }

    const validateDocument = (value) => {
        return onCheckDocument(value, setFieldError);
    };
    React.useEffect(() => {
        setTimeout(() => {
            const elem = document.getElementById("canvas-container");
            if (elem !== null) {
                const width = Math.min(500, elem.getBoundingClientRect().width - 10);
                const heigth = Math.min(((width * 9) / 16), 200);
                setCanvasWidth(width);
                setCanvasHeight(heigth);
            }

        }, 100);
        if (Object.keys(values.clauses).length === 4) {
            return;
        }
        const negativeDefaultClauses = {};
        clauses.forEach(clause => {
            negativeDefaultClauses[clause.id] = getUnCheckedValue(clause);
        });
        setFieldValue('clauses', negativeDefaultClauses);
    }, [clauses]);
    useEffect(() => {
        if (values.hash === '') {
            setFieldValue('hash', generateUuid());
        }
    }, []);
    const getFranjas = () => {
        if (existsKeyInCampaign('create_lead.franjas', campaign)) {
            return JSON.parse(getValueOrDefault('create_lead.franjas', campaign));
        }
        return [];
    }
    const getCompanies = () => {
        if (existsKeyInCampaign('create_lead.companies', campaign)) {
            let data = getValueOrDefault('create_lead.companies', campaign, '{}');
            data = JSON.parse(data);
            return Object.values(data);
        }
        return [];
    }
    const getServiceType = () => {
        if (existsKeyInCampaign('create_lead.service_type', campaign)) {
            let data = getValueOrDefault('create_lead.service_type', campaign, '{}');
            data = JSON.parse(data);
            return Object.values(data);
        }
        return [];
    }
    const clearContactHourLast = (e) => {
        setFieldValue('contactHourLast', '');
    }

    const sendSms = () => {
        onSendSms({hash: values.hash, phone: values.phone}).then(a => {
            setFieldValue('smsSended', true);
        }).catch(e => {

        })
    }

    const confirmSmsAction = () => {
        const code = values.confirmPhone;
        onConfirmSms({code, hash: values.hash}).then(res => {
            if (res === true) {
                setFieldValue('smsConfirmed', true);
                setSmsconfirmed(true);
                setSmsCodeError(false);
            } else {
                setSmsconfirmed(false);
                setSmsCodeError(true);
            }
        }).catch(e => {

        })
    }
    let phoneConfirmationEnabled = getPhoneConfirmedEnabled(campaign, user);
    const getStyleConfirmPhone = () => {
        return (values.smsSended === true && !values.smsConfirmed) ? {display: 'block'} : {display: 'none'};
    }
    const isValidPhoneConfirmed = () => {
        if (phoneConfirmationEnabled === true) {
            return smsConfirmed && isValid;
        }
        return isValid;
    }

    return (
        <div className="box">
            <h1>Alta de Lead</h1>
            <Divider/>
            <form onSubmit={submit}>
                <Grid className="register-lead-form-block" columns={1} columnGap="0" rowGap="15px">
                    <h2>Datos Personales</h2>
                    <Divider/>
                    <Field name="name" required
                           label="Nombre" component={MaterialTextField} variant="outlined"/>
                    <Field name="surname1" required
                           label="Apellido 1" component={MaterialTextField}  variant="outlined"/>
                    <Field name="surname2" component={MaterialTextField}
                           label="Apellido 2" variant="outlined"/>
                    <Field name="documentType" variant="outlined" required
                           label="Selecciona el Tipo de Documento"
                           component={SelectField}
                           errortext="Escoge un tipo de Documento" labelId="register-lead-document-type-label"
                           onChangeField={() => {
                               setFieldValue('document', '');
                           }}
                    >
                        {documents.map((documentType) => {
                            return <MenuItem key={documentType.name}
                                             value={documentType.idEvent}>{documentType.showName}</MenuItem>
                        })}
                    </Field>
                    <Field name="document" disabled={values.documentType === undefined || values.documentType === ''}
                           required variant="outlined"
                           component={MaterialTextField} type="text"
                           innerRef={documentRef}
                           label="Documento"
                    />

                    <Field name="codigoPostal"
                           label="Código Postal" component={MaterialTextField} variant="outlined"/>
                    <h2>Datos de Contacto</h2>
                    <Divider/>
                    <Field name="prefix" variant="outlined" component={MaterialTextField} type="number"
                                label="Prefijo" 
                                helperText="Prefijo del número de teléfono correspondiente al pais"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">+</InputAdornment>,
                                  }}
                                  />
                    {phoneConfirmationEnabled ?
                        <div className={'phone-field'}>
                            <Field name="phone" disabled={values.smsSended ? true : false} required variant="outlined"
                                   component={MaterialTextField} type="telefono"
                                   label="Teléfono" helperText="Se tendrá que confirmar por SMS el teléfono"/>
                            {values.smsSended === false ?
                                <React.Fragment>
                                    <div>
                                        <Button disabled={props.errors.phone ? true : false} onClick={sendSms}
                                                variant="contained" color="secondary" type="button">
                                            Enviar SMS
                                        </Button>
                                    </div>
                                </React.Fragment>
                                : null}
                            <React.Fragment>
                                <div style={getStyleConfirmPhone()}>
                                    <Field name="confirmPhone" required variant="outlined" component={MaterialTextField}
                                           type="telefono"
                                           label="Código de confirmación de teléfono"/>
                                    <a onClick={sendSms} className="cursor">
                                        Volver a enviar SMS
                                    </a>
                                </div>
                                <div><Button variant="contained" color="secondary" type="button"
                                             onClick={confirmSmsAction} style={getStyleConfirmPhone()}>
                                    Confirmar
                                </Button>
                                    {smsCodeError ? <div className="error-form">El código no es correcto</div> : null}
                                </div>
                            </React.Fragment>

                        </div>
                        : <Field name="phone" required variant="outlined" component={MaterialTextField} type="telefono"
                                 label="Teléfono" helperText="Debe ser un número de teléfono válido"/>}
                    <Field name="email" variant="outlined" component={MaterialTextField} type="email"
                           label="Email"/>
                    <h2>Datos de Contrato</h2>
                    <Divider/>
                    <Field name="company" 
                        variant="outlined" 
                        component={SelectField}
                        type="text"
                        label="Compañia Actual">
                        {getCompanies().map((v, k) => {
                                    return <MenuItem key={k}
                                        value={v}>{v}</MenuItem>
                                })}
                    </Field>
                    <Field name="serviceType" 
                        variant="outlined" 
                        component={MultiSelectField}
                        type="text"
                        label="Fibra/Tv/ Móvil">
                        {getServiceType().map((v, k) => {
                                    return <MenuItem key={k}
                                        value={v}>{v}</MenuItem>
                                })}
                    </Field>
                    <Field name="contractHolder" variant="outlined" component={MaterialTextField} type="text"
                           label="Titular del contrato"/>
                    {/*<Field name="contactHour" variant="outlined" component={MaterialTextField}*/}
                    {/*       type="time"*/}
                    {/*       label="Hora de contacto desde"*/}
                    {/*       InputLabelProps={{*/}
                    {/*           shrink: true,*/}
                    {/*       }}*/}
                    {/*/>*/}
                    <Field name="franjas" variant="outlined" required
                           label="Franja Horarias de contacto"
                           component={SelectField}
                           errortext="Selecciona una franja horaria de contacto"
                           labelId="register-lead-document-type-label"
                    >
                        {getFranjas().map((v, k) => {
                            return <MenuItem key={k}
                                             value={v.franja}>{v.franja}</MenuItem>
                        })}

                    </Field>
                    <Field name="preferenciaDia" variant="outlined"
                           label="Preferencia día"
                           component={MaterialTextField}
                           errortext="Selecciona un dia de preferencia"
                           labelId="register-lead-document-type-label"
                    >
                    </Field>
                    {/*<Field name="contactHourLast" variant="outlined" component={MaterialTextField}*/}
                    {/*       type="time"*/}
                    {/*       InputLabelProps={{*/}
                    {/*           shrink: true,*/}
                    {/*       }}*/}
                    {/*       label="Hora de contacto hasta"/>*/}

                    <h2>Stand</h2>
                    <Field name="stand"
                        label="Elige un stand"
                        labelAttr='mall'
                        component={AutocompleteUser}
                        load={filterStands}
                        loadParams={getStandFilterParams}
                        variant="outlined"
                        defaultFirst={true}
                        className="form-control"
                    />

                    <Divider/>
                    <h2>Observaciones</h2>
                    <Field name="observations" variant="outlined" component={MaterialTextField} type="text"
                           label="Observaciones" multiline={true} rowsMax={14} rows={8}/>
                    <Divider/>
                    <h2>Clausulas de Privacidad</h2>
                    <Divider/>
                    <FormGroup>
                        {clauses.map((clause, index) => {
                            return (<Field key={index}
                                           name={`clauses[${clause.id}]`}
                                           component={CheckboxField}
                                           arrayindex="clauses"
                                           index={clause.id}
                                           label={clause.description} checkedValue={() => {
                                    return getCheckedValue(clause)
                                }}
                                           uncheckedValue={() => {
                                               return getUnCheckedValue(clause)
                                           }}/>
                            )
                        })}
                    </FormGroup>
                    <h2>Firma</h2>
                    <Divider/>
                    <div id="canvas-container">
                        <p>Intenta rellenar todo el cuadro</p>
                        <div className="canvas-container">
                            <SignatureCanvas penColor='black'
                                             ref={(ref) => setCanvasRef(ref)}
                                             canvasProps={{
                                                 width: canvasWidth,
                                                 height: canvasHeight,
                                                 className: 'sigCanvas'
                                             }}/>
                        </div>
                        {canvasEmpty ? <p className="error-form">
                            La firma está vacia
                        </p> : null}
                        <Button variant="contained" color="primary" type="button" onClick={resetCanvas}>Limpiar
                            Firma</Button>
                    </div>

                </Grid>
                <div style={{margin: '15px'}}>
                    {!smsConfirmed && phoneConfirmationEnabled ? <p className="error-form">
                        Debes confirmar el número de teléfono por SMS.
                    </p> : null}
                </div>
                <Button className="register-user-button"
                        disabled={!isValid}
                        variant="contained" color="secondary" type="submit">Registrar
                    Lead</Button>
            </form>
        </div>
    )
}
const schema = ({user, campaign, props}) => {
    // const getConfiguracionCardBono = () => {

    //     if (existsKeyInCampaign('create_lead.cardbono.config', campaign)) {
    //         return getValueOrDefault('create_lead.cardbono.config', campaign);
    //     }
    //     return;
    // }

    const fields = {
        name: Yup.string().required('Obligatorio'),
        document: Yup.string().required('Obligatorio').test('document', 'No se ha validado el documento o es desconocido con más de 10 carácteres',
            function (value) {
                const {documentType} = this.parent;
                if (documentType == 2 || documentType == 3) {
                    return validNif(value);
                }
                if (documentType === 1) {
                    return validCif(value);
                }
                if (!value) {
                    return true;
                }
                return value.length < 10;
            }),
        surname1: Yup.string().required('Obligatorio').test('len', 'No puede contener mas de 100 carácteres', val => {
            if (!val) {
                return true;
            }
            return val.length <= 100
        }),
        surname2: Yup.string().test('len', 'No puede contener mas de 100 carácteres', val => {
            if (!val) {
                return true;
            }
            return val.length <= 100
        }),
        observations: Yup.string().test('len', 'No puede contener mas de 150 carácteres', val => {
            if (!val) {
                return true;
            }
            return val.length <= 150
        }),
        codigoPostal: Yup.string().test('len', 'No puede contener mas de 10 carácteres', val => {
            if (!val) {
                return true;
            }
            return val.length <= 10
        }),
        prefix: Yup.string().test('len', 'No puede contener mas de 10 carácteres', val => {
            if (!val) {
                return true;
            }
            return val.length <= 10
        }),
        preferenciaDia: Yup.string().test('len', 'No puede contener mas de 100 carácteres', val => {
            if (!val) {
                return true;
            }
            return val.length <= 100
        }),
        documentType: Yup.string().required('Obligatorio'),
        hash: Yup.string(),
        confirmPhone: Yup.string().required(''),
        email: Yup.string().email('Tiene que ser un email válido'),
        company: Yup.string(),
        contractHolder: Yup.string(),
        phone: Yup.string().required('Obligatorio').test('is-phone', "No es un número de teléfono válido", value => validatePhone(value)),
        stand: Yup.object().nullable(),
        contactHour: Yup.string(),
        franjas: Yup.string(),
        contatHourLast: Yup.string(),
    }
    let phoneConfirmationEnabled = getPhoneConfirmedEnabled(campaign, user);
    if (phoneConfirmationEnabled) {
        fields.smsConfirmed = Yup.boolean().required('Debes confirmar el teléfono');
        fields.smsSended = Yup.boolean(false)
        fields.cardbono = Yup.string()
    }
    const res = Yup.object().shape(fields);

    return res;
}

RegisterLeadFormAdamo = withFormik(
    {
        validationSchema: schema,
        mapPropsToValues: (props) => {
            let phoneConfirmationEnabled = getPhoneConfirmedEnabled(props.campaign, props.user);
            const fields = {
                name: '',
                surname1: '',
                surname2: '',
                documentType: '',
                document: '',
                codigoPostal: '',
                prefix: '',
                phone: '',
                email: '',
                contactHourLast: '',
                franjas: 'LLAMAR YA',
                preferenciaDia: '',
                serviceType: [],
                hash: '',
                smsSended: false,
                company: '',
                contractHolder: '',
                clauses: {},
                contactHour: '',
                stand: {id: 0, mall: 'Ninguno'}
            };
            fields.cardbono = '';
            fields.smsSended = false;
            fields.smsConfirmed = false;
            return fields;
        },
        handleSubmit: async (vals, props) => {
            props.setSubmitting(false);
            const values = {...vals};
            if (values.stand !== null) {
                if (values.stand.id !== 0) {
                    values.stand = vals.stand.id;
                } else {
                    values.stand = null;
                }
            }
            log(`Enviando Lead`, "info");
            return await props.props.onLeadRegister(values)
                .then((e) => {
                    props.resetForm();
                    props.setFieldValue('observations', '');
                    props.setFieldValue('hash', generateUuid());
                    props.setFieldValue('confirmPhone', '');
                    const negativeDefaultClauses = {};
                    const clauses = props.props.defaultClauses;
                    clauses.forEach(clause => {
                        negativeDefaultClauses[clause.id] = getUnCheckedValue(clause);
                    });
                    props.setFieldValue('clauses', negativeDefaultClauses);
                    props.setFieldValue('observations', '');
                    log(`Lead Enviado con éxito`, "info");
                });
        },
        displayName: 'Registrar Lead',
    }
)(RegisterLeadFormAdamo);

const mapDispatchToProps = dispatch => {
    let timer = null;
    return {
        onLeadRegister: async data => {
            return await registerLeadAdamo(data)(dispatch)
        },
        onSendSms: async data => {
            return await sendSmsConfirmationEvent(data)(dispatch)
        },
        onConfirmSms: async data => {
            return await confirmSmsEvent(data)(dispatch)
        },
        onCheckDocument: (document, setFieldError) => {
            let value = undefined;
            if (document.target) {
                value = document.target.value;
            } else {
                value = document;
            }

            clearTimeout(timer);
            timer = setTimeout(() => call(
                () => {
                    return documentExists(value).then((res) => {
                        setFieldError('document', 'El documento ya está dado de alta')
                        return 'El documento ya está registrado';
                    }).catch((err) => {
                        setFieldError('document', null);
                        return null;
                    })
                }
                , 'check-document', false)(dispatch), 1000);

        }
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        campaign: state.campaign
    }
}


RegisterLeadFormAdamo = connect(mapStateToProps, mapDispatchToProps)(RegisterLeadFormAdamo);
export default RegisterLeadFormAdamo;




